import { render, staticRenderFns } from "./FITBAggregate.vue?vue&type=template&id=30c8ec58&"
import script from "./FITBAggregate.vue?vue&type=script&lang=js&"
export * from "./FITBAggregate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports